import { AppConstant } from 'src/app/config/app.constant';
import { map } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api.service';
import { Injectable } from "@angular/core";
import { APIs } from '../config/api.constant';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ParkiteReportService {
    
  constructor(private apiService: ApiService) { }
 
  getFireWardenReportData(body?: any): Observable<any> {
    return this.apiService.post(APIs.getFireWardenReportData, body,'',{
        Authorization : "bearer " + localStorage.getItem(AppConstant.localStorage.token)
      }).pipe(map(response => {
        return response;
      })); 
  };

  getVMSReportData(body?: any): Observable<any> {
    return this.apiService.post(APIs.getVMSReportData, body,'',{
        Authorization : "bearer " + localStorage.getItem(AppConstant.localStorage.token)
      }).pipe(map(response => {
        return response;
      })); 
  };

  getInvitationType(): Observable<any> {
     
    const paramObj = {
    };
    return this.apiService.get(APIs.getInvitationType, paramObj).pipe(map(response => {
      return response;
    }));
  };

  getEventsCategory(): Observable<any> {
    return this.apiService.get(APIs.getEventsCategoryData, '',{
        Authorization : "bearer " + localStorage.getItem(AppConstant.localStorage.token)
      }).pipe(map(response => {
        return response;
      })); 
  };

  getEventsReportData(body?: any): Observable<any> {
    return this.apiService.post(APIs.getEventsReportData, body,'',{
        Authorization : "bearer " + localStorage.getItem(AppConstant.localStorage.token)
      }).pipe(map(response => {
        return response;
      })); 
  };
}
